import {Accordion, AccordionDetails, AccordionSummary, alpha, Skeleton} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import React, {FC, useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {getRandomStepsArray, IStep, IStepNormalized} from "../../../store/how-it-works/Helper";
import Box from "@mui/material/Box";
import {getRandomNumber} from "../../../util/utils";
import {useTheme} from "@mui/material/styles";
import MarkdownWrapper from "../../shared/markdown-wrapper/MarkdownWrapper";

interface IProps {
    steps: IStep[]
    loading: boolean
    type: "" | "alternative_"
}

const StepsSmall: FC<IProps> = (props) => {
    const {i18n} = useTranslation()
    const [expandedAccordion, setExpandedAccordion] = useState(0)
    const theme = useTheme()

    useEffect(() => {
        setExpandedAccordion(0)
    }, [props.type]);

    const stepsNormalized: IStepNormalized[] = useMemo(() => {
        const lang = i18n.language;

        const getValue = (step: any, key: string) => {
            const specific = step[`${props.type}${key}_${lang}`];
            const fallback = props.type === "alternative_" ? step[`${key}_${lang}`] : null;
            return specific ?? fallback ?? null;
        };

        return props.steps
            .map((s) => ({
                title: getValue(s, "title"),
                subtitle: getValue(s, "subtitle"),
                gif: getValue(s, "gif_mobile"),
            }))
            .filter((s) => !!s.title);
    }, [props.steps, props.type, i18n.language]);

    const handleOnChangeAccordion = (idx: number) => {
        setExpandedAccordion(idx)
    }

    return (
        <>
            {(props.loading ? getRandomStepsArray() : stepsNormalized).map((step, idx) =>
                (
                    <Accordion key={step.title}
                               sx={{backgroundColor: "inherit"}} expanded={idx === expandedAccordion}
                               onChange={() => handleOnChangeAccordion(idx)}>
                        <AccordionSummary
                            expandIcon={<ExpandMore color="primary"/>}
                            aria-controls={`how-it-works-step-${idx}-content`}
                            id={`how-it-works-step-${idx}-header`}
                            sx={{
                                backgroundColor: alpha(theme.palette.primary.main, .05),
                                backdropFilter: "blur(5px)"
                            }}
                        >
                            <Typography color="primary" variant="h5"
                                        fontWeight={600}>
                                {props.loading ?
                                    <Skeleton width={`${getRandomNumber(100, 150)}px`} animation='wave'/> :
                                    `${idx + 1}. ${step.title}`}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails
                            sx={{
                                backgroundColor: alpha(theme.palette.primary.main, .15),
                                backdropFilter: "blur(5px)"
                            }}>
                            <Box display="flex" justifyContent="center" my={1}>
                                {!props.loading ?
                                    <img
                                        src={step.gif}
                                        alt={step.title}
                                        width={150}
                                        style={{borderRadius: '0.5em'}}/> :
                                    <Skeleton variant='rectangular' animation='pulse' width='150px' height='250px'/>}
                            </Box>
                            <MarkdownWrapper
                                source={step.subtitle}
                                loading={props.loading}
                                sx={{mt: 2}}/>
                        </AccordionDetails>
                    </Accordion>
                ))}
        </>

    )
}

export default StepsSmall
